var map = {
	"./bel9850/placeholder.png": "HF3a",
	"./lekkerhot/placeholder.png": "1Iba"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Jhb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/placeholder\.png$
// module id = Jhb6
// module chunks = 0